/*jshint esversion: 6 */
import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AuthService } from '../../services/authService';
import { UserMessageService } from '../../services/userMessageService';
import { WhiteLabelWhiteLabelAdminAPI } from '../../services/wladmin/whitelabelWhiteLabelAdminAPI';
import { PaymentWhiteLabelAdminAPI } from '../../services/wladmin/paymentWhiteLabelAdminAPI';

@inject(AuthService, Router, WhiteLabelWhiteLabelAdminAPI, PaymentWhiteLabelAdminAPI, UserMessageService)
export class WhiteLabel {
  constructor(authService, router, api, paymentAdminApi, userMessageService) {
    this.authService = authService;
    this.router = router;
    this.api = api;
    this.paymentAdminApi = paymentAdminApi;
    this.userMessageService = userMessageService;
  
    this.saving = false;
    this.loading = true;
    this.refreshAfterSave = false;
  }

  activate() {
    this.loading = true;
    this.reset();
  
    this.paymentAdminApi.getPublicApiKey(this.authService.getUser().token, this.apiKeySuccess.bind(this), this.saveLoadError.bind(this), -1);
    this.id = this.authService.getUser();
    console.log('id', this.id);
  }

  // attached() {
  //   this.paymentAdminApi.getPublicApiKey(this.authService.getUser().token, this.apiKeySuccess.bind(this), this.saveLoadError.bind(this));
  // }

  reset() {
   
    this.businessName = null;
    this.billingAddress = null;
    this.contactPhone = null;
    this.contactEmail = null;
    this.contactFirstName = null;
    this.contactLastName = null;
    this.domainName = null;
  }


  apiKeySuccess(key) {
    this.renderStripe(key);
    this.loading = false;
    // this.load();
  
  }

  saveLoadSuccess(id) {

    if (this.saving) {
      this.userMessageService.setUserMessage('user', 'White Label Created!');
      this.router.navigate(`whitelabel/${id}`)
    }
    this.saving = false;
    this.loading = false;
  }

  saveLoadError(msg) {
    this.userMessageService.setUserError('user', msg);
    this.loading = false;
    this.saving = false;
  }


  getWhiteLabelData(payment_token) {
    var data = {
      'business_name': this.businessName,
      'billing_addr': this.billingAddress,
      'contact_first_name': this.contactFirstName,
      'contact_last_name': this.contactLastName,
      'contact_email': this.contactEmail,
      'contact_phone': this.contactPhone,
      'domain_name': this.domainName,
      'payment_token': payment_token,
      'parent_id' : this.id.whitelabel_id
    };

    return data;
  }

  validate() {
    var pass = true;

    if (this.businessName === null || this.businessName.trim() == '' ) {
      this.userMessageService.setUserError('user', 'Business Name is empty');
      pass = false;
    }

    if (this.billingAddress === null || this.billingAddress.trim() == '' ) {
      this.userMessageService.setUserError('user', 'Billing Address is empty');
      pass = false;
    }

    if (this.contactFirstName === null || this.contactFirstName.trim() == '' ) {
      this.userMessageService.setUserError('user', 'Contact First Name is empty');
      pass = false;
    }

    if (this.contactLastName === null || this.contactLastName.trim() == '' ) {
      this.userMessageService.setUserError('user', 'Contact Last Name is empty');
      pass = false;
    }

    if (this.contactEmail === null || this.contactEmail.trim() == '' ) {
      this.userMessageService.setUserError('user', 'Contact Email is empty');
      pass = false;
    }

    if (this.contactPhone === null || this.contactPhone.trim() == '' ) {
      this.userMessageService.setUserError('user', 'Contact Phone is empty');
      pass = false;
    }

    if (this.domainName === null || this.domainName.trim() == '' ) {
      this.userMessageService.setUserError('user', 'Domain Name is empty');
      pass = false;
    }

    


    return pass;
  }

  is_email(email) {
    var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    return emailReg.test(email);
  }

  creditsChanged() {
    var value = parseInt(this.new_request_count, 10);

    if (isNaN(value)) {
      this.new_request_count = this.request_count;
    } else {
      this.request_count = this.new_request_count;
    }
  }


  save() {

    if (this.validate()) {
      this.saving = true;

      this.stripe.createToken(this.card, { name: this.cardholderName }).then(function (result) {
        if (result.error) {
          // Inform the user if there was an error
          this.saving = false;
          this.displayError.textContent = result.error.message;
        } else {
          // Send the token to your server
          this.api.create(
            this.getWhiteLabelData(result.token.id),
            this.authService.getUser().token,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this));
        }
      }.bind(this));

    }
  }

  renderStripe(key) {
    // Create a Stripe client
    this.stripe = Stripe(key);

    // Create an instance of Elements
    this.elements = this.stripe.elements();

    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    var style = {
      base: {
        color: '#32325d',
        lineHeight: '24px',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    };

    // Create an instance of the card Element
    this.card = this.elements.create('card'/*, { style: style }*/);

    // Add an instance of the card Element into the `card-element` <div>
    this.card.mount('#card-element');

    // Handle real-time validation errors from the card Element.
    this.card.addEventListener('change', function (event) {

      if (event.error) {
        this.displayError.textContent = event.error.message;
      } else {
        this.displayError.textContent = '';
      }
    }.bind(this));
  }

  

  validate() {
    var pass = true;

    if (this.businessName === null || this.businessName.trim() == '' ) {
      this.userMessageService.setUserError('user', 'Business Name is empty');
      pass = false;
    }

    if (this.billingAddress === null || this.billingAddress.trim() == '' ) {
      this.userMessageService.setUserError('user', 'Billing Address is empty');
      pass = false;
    }

    if (this.contactEmail === null || this.contactEmail.trim() == '' ) {
      this.userMessageService.setUserError('user', 'Contact Email is empty');
      pass = false;
    }

    if (this.contactPhone === null || this.contactPhone.trim() == '' ) {
      this.userMessageService.setUserError('user', 'Contact Phone is empty');
      pass = false;
    }

    if (this.domainName === null || this.domainName.trim() == '' ) {
      this.userMessageService.setUserError('user', 'Domain Name is empty');
      pass = false;
    }

    return pass;
  }

  is_email(email) {
    var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    return emailReg.test(email);
  }

}
